<div class="numpad-tpr">
  <div class="numpad-tpr__display">
    <sz-num-focal [value]="displayValue()" unit="s" size="xl" />
  </div>
  <sz-numpad-grid [keys]="keys()" (press)="onKeyPress($event)" />
  <div class="numpad-tpr__footer">
    <sz-button variant="secondary" size="sm" (click)="cancel.emit()">
      {{ 'common.cancel' | translate }}
    </sz-button>
    <sz-button variant="primary" [disabled]="!canSubmit()" (click)="submit()">
      <sz-icon name="check" [size]="16" />
      {{ 'session.numpad.saveRunCta' | translate }}
    </sz-button>
  </div>
</div>
